import {
    FETCH_AGGREGATE_RESULTS_REQUEST,
    FETCH_AGGREGATE_RESULTS_SUCCESS,
    FETCH_AGGREGATE_RESULTS_FAILURE,
} from '../actions/types/aggregate-results-action-types';

import { combineReducers } from 'redux';

function isLoading( state = false, action ){
    let newState;
    switch( action.type ){
        case FETCH_AGGREGATE_RESULTS_REQUEST:
            newState = true;
            break;
        case FETCH_AGGREGATE_RESULTS_SUCCESS:
        case FETCH_AGGREGATE_RESULTS_FAILURE:
            newState = false;
            break;
        default:
            return state;
    }

    return newState;
}

function bySenderId( state = {}, action ){
    let newState;
    switch( action.type ){
        case FETCH_AGGREGATE_RESULTS_SUCCESS:
            newState = action.aggResultsBySender;
            break;
        case FETCH_AGGREGATE_RESULTS_FAILURE:
            newState = {};
            break;
        default:
            return state;
    }

    return newState;
}

function allSenderIds( state = [], action ){
    let newState;
    switch( action.type ){
        case FETCH_AGGREGATE_RESULTS_SUCCESS:
            newState = action.allSenderIds;
            break;
        case FETCH_AGGREGATE_RESULTS_FAILURE:
            newState = [];
            break;
        default:
            return state;
    }

    return newState;
}

function byDomainId( state = {}, action ){
    let newState;
    switch( action.type ){
        case FETCH_AGGREGATE_RESULTS_SUCCESS:
            newState = action.aggResultsByDomain;
            break;
        case FETCH_AGGREGATE_RESULTS_FAILURE:
            newState = {};
            break;
        default:
            return state;
    }

    return newState;
}

function allDomainIds( state = [], action ){
    let newState;
    switch( action.type ){
        case FETCH_AGGREGATE_RESULTS_SUCCESS:
            newState = action.allDomainIds;
            break;
        case FETCH_AGGREGATE_RESULTS_FAILURE:
            newState = [];
            break;
        default:
            return state;
    }

    return newState;
}

function params( state = null, action ){
    let newState;
    switch( action.type ){
        case FETCH_AGGREGATE_RESULTS_REQUEST:
            newState = action.params;
            break;
        case FETCH_AGGREGATE_RESULTS_FAILURE:
            newState = null;
            break;
        default:
            return state;
    }

    return newState;
}

export default combineReducers( {
    allDomainIds,
    allSenderIds,
    byDomainId,
    bySenderId,
    isLoading,
    params,
} );
